import { FormControlLabel, Switch, useTheme } from "@material-ui/core";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import { useEffect } from "react";
import { useCommProvider } from "../../api/CommProvider";
import { useDataProvider } from "../../api/DataProvider";
import { useCustomTheme } from "../../api/ThemeProvider";

export function ThemeButton({handleThemeSwitch, ...rest }) {
    const theme = useTheme();
    const { toggleTheme, setToggleTheme } = useCustomTheme(false)
    const { currentUser, token_id, json_data_USER, set_json_data_USER } = useDataProvider();
    const { comm_updateTheme, comm_updateSession } = useCommProvider();


    /* Check theme */
    useEffect(() => {
        // console.log('ThemeButton')
        if (json_data_USER !== null && json_data_USER !== undefined) {
            setToggleTheme(json_data_USER.session.theme) 
        }
    }, [json_data_USER])

    /* Change theme & Save preferences */
    async function handleTheme(e) {
        const sw = e.target.checked;
        handleThemeSwitch(e, sw);
        sw ? setToggleTheme(true) : setToggleTheme(false)
        try{
            const response = await comm_updateSession(token_id, currentUser, {'theme': sw})
            set_json_data_USER({...json_data_USER, session: {...json_data_USER.session, theme: response['session']['theme']}});
        }catch(err){
            console.error(err)
        }
    };

    return (
        <FormControlLabel {...rest}
            control={
                <>
                    < Switch color="default" onClick={handleTheme} checked={toggleTheme || false} />
                    {theme.palette.type === 'dark' ? <Brightness7 /> : <Brightness4 />}
                </>}
            labelPlacement="start"
        />
    )
}